import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import { isPicture, isVideo } from '../../utils/helpers';
import { FileUrl } from '../../utils/api/services/files';
import ContentPreloader from '../Preloader/ContentPreloader';

export default class AttachedContent extends Component {
  static propTypes = {
    filename: PropTypes.string,
    fileId: PropTypes.string,
    alt: PropTypes.string,
    className: PropTypes.string,
    isPreview: PropTypes.bool,
    to: PropTypes.string,
    vimeoLink: PropTypes.string,
    vimeoVideoId: PropTypes.string,
    vimeoPreviewUrl: PropTypes.string
  };

  static defaultProps = {
    alt: '',
    className: '',
    isPreview: false,
    to: ''
  };

  render() {
    const {
      filename,
      fileId,
      vimeoLink,
      vimeoVideoId,
      alt,
      className,
      isPreview,
      to,
      vimeoPreviewUrl
    } = this.props;
    if (vimeoLink) {
      return (
        <div className={classnames(className, 'video-player')}>
          <ContentPreloader />
          <iframe
            className="video-player__frame"
            src={vimeoLink}
            title={alt}
            frameBorder="0"
            allowFullScreen
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
          />
        </div>
      );
    }
    if (vimeoVideoId && isPreview && vimeoPreviewUrl) {
      return (
        <React.Fragment>
          <img src={vimeoPreviewUrl} className={className} alt={alt} />
          <Link to={to}>
            <div className="card-btn-play" />
          </Link>
        </React.Fragment>
      );
    }
    if (isPicture(filename)) {
      return <img src={FileUrl(fileId)} className={className} alt={alt} />;
    }
    if (isVideo(filename)) {
      if (isPreview) {
        return (
          <React.Fragment>
            <video preload="metadata" className={className}>
              <source src={FileUrl(fileId)} />
            </video>
            <Link to={to}>
              <div className="card-btn-play" />
            </Link>
          </React.Fragment>
        );
      }
      return (
        <video controls className={className}>
          <source src={FileUrl(fileId)} />
          {'Ошибка: Ваш браузер не поддерживает воспроизведение видео.'}
        </video>
      );
    }
    return '';
  }
}
